export default {
	props: {
		label: String,
		info: String,
		name: {
			type: String,
			required: true,
		},
		placeholder: String,
		required: {
			type: Boolean,
			default: false,
		},
		type: {
			type: String,
			default: 'text',
		},
		min: String,
		max: String,
		disabled: {
			type: Boolean,
			default: false,
		},
		value: null,
		errors: Array,
		inputmode: String,
	},
	computed: {
		im() {
			// Can override by passing a prop
			if (this.inputmode) return this.inputmode

			// Sensible defaults
			switch (this.type) {
				case 'email':
					return 'email'
				case 'number':
					return 'decimal'
				case 'integer':
					return 'numeric'
				default:
					return undefined
			}
		},
		bind() {
			return {
				id: this.name,
				name: this.name,
				placeholder: this.placeholder,
				type: this.type === 'integer' ? 'text' : this.type,
				min: this.min,
				max: this.max,
				disabled: this.disabled,
				...(this.im && { inputmode: this.im }),
			}
		},
		model: {
			get() {
				return this.value
			},
			set(value) {
				if (!this.disabled) {
					if (this.type === 'integer') {
						// Parse numbers ourselves because Vue is bad
						const next =
							value.trim() === '' ? null : isNaN(Number(value)) ? this.model : Number(value)

						// Emit raw next value, then sanitised value next tick
						this.$emit('input', value)
						this.$nextTick(() => {
							this.$emit('input', next)
						})
					} else {
						// Just emit everything else
						this.$emit('input', value)
					}
				}
			},
		},
		wrapper() {
			return {
				name: this.name,
				label: this.label,
				info: this.info,
				error: this.error,
				required: this.required,
				disabled: this.disabled,
			}
		},
	},
}
